import { Link } from 'react-router-dom';

const PrivacyPolicy = () => (
  <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
    <Link to="/">← Back to Home</Link>
    <section>
<h1>Privacy Policy for Remind Me of My Scriptures</h1>
<p><em>Last Updated: December 24, 2025</em></p>

<h2>1. Introduction</h2>
<p>"Remind Me of My Scriptures" ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains our practices regarding the collection and use of information through our mobile application. We operate as an Individual entity.</p>

<h2>2. Information We Collect</h2>
We do not collect personal information (such as names, email addresses, or phone numbers). However, we use Google Analytics to understand app usage.

Usage Data: We track app activity (e.g., which features are used) to improve the user experience.

Location Data: We may collect general location data (IP-based) through Google Analytics to understand our user base's geographic distribution.

<h2>3. No Advertisements and Third Parties</h2>
No Ads: Our app does not show or use advertisements.

No Remarketing: We do not use remarketing services to advertise to you on third-party websites after you have used our App.

No Sales: We do not sell your data to third parties.

<h2>4. Data Security and Storage</h2>
Your scripture data (categories, added verses, etc.) is stored locally on your device. We do not have access to your personal scripture library. We only receive the anonymized aggregate data provided by Google Analytics.

<h2>5. Contact Information</h2>
If you have any questions regarding this Privacy Policy or our practices, please contact us at:

Email: jspiritcodedeveloper@gmail.com


    </section>
  </div>
);

export default PrivacyPolicy;